export default "__VITE_ASSET__5WncxLt2__"